import { action } from 'typesafe-actions';
import { GlobalActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const globalLoad = (data): any => action(types.GLOBAL_LOAD_REQUESTED, data);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  globalLoadPending: (): any => action(types.GLOBAL_LOAD_PENDING, {}),
  globalLoadFinished: (): any => action(types.GLOBAL_LOAD_FINISHED, {}),
};

export default null;
